module.exports = __webpack_public_path__ + "static/Customizable-Cell-Editor-c5caeaefcbf3cf10a131010f21a82511.png";